import styled from 'styled-components'

export const Pulse = styled.circle`
    animation: pulse 1800ms infinite ease;

    @keyframes pulse {
        0%,
        100% {
            opacity: 0.15;
            transform: scale(1);
        }
        50% {
            opacity: 0.2;
            transform: scale(1.5);
        }
    }
`

export const MiddlePulseContentContainer = styled.div`
    .top-event-title {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        text-align: center;
        font-weight: bold;
        font-size: 14px;
        overflow-wrap: break-word;
        line-height: normal;
        vertical-align: middle;
        overflow: hidden;
        min-height: 48px;
        /* color: ${({ theme }) => theme.static['gray-1000']}; */
        color: #000;
    }

    .bowtieStatus {
        overflow: auto;
        margin-top: 6px;
        /* margin-left: 23px; */
        display: -webkit-box;
        -webkit-box-orient: horizontal;
        -webkit-line-clamp: 1;
        text-align: center;
        font-weight: bold;
        justify-content: center;
        font-size: 12px;

        svg {
            margin-left: 8px;
        }
    }

    .alarpcontainer {
        display: -webkit-box;
        -webkit-box-orient: horizontal;
        -webkit-line-clamp: 1;
        text-align: center;
        font-size: 13px;
        font-family: var(--font-semibold);
        justify-content: center;
        color: ${({ theme }) => theme.static['gray-1000']};
    }

    .alarp {
        display: inline;
    }

    .alarpvalue {
        display: inline;
    }

    .limit {
        display: -webkit-box;
        -webkit-box-orient: horizontal;
        -webkit-line-clamp: 1;
        text-align: center;
        font-size: 11px;
        font-family: var(--font-regular);
        line-height: 10px;
        justify-content: center;
        color: ${({ theme }) => theme.static['gray-1000']};
    }
`

export const TextContainer = styled.div`
    display: -webkit-box;
    line-height: 16px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 12px;
    font-family: ${({ theme }) => theme['font-regular']};

    color: ${({ theme }) => theme['gray-1000']};
    margin: 0;
`
